module.exports = __webpack_public_path__ + "media/images/category_icons/cities-51997b46b3a11b9175d773dc581155f3.svg";